import React, { useState } from 'react';
import { View, Text, Alert } from 'react-native';
import { oExercises } from '../olonkho-exercises';
import { oStyles } from '../olonkho-styles';
import { OTextInput, OAnswerButton } from '../olonkho-fw'

export default function Exercises({ navigation }) {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [isAnswer, setIsAnswer] = useState();
    const [correctAnswers, setCorrectAnswers] = useState(0);

    return (
        <View style={ { flex: 1 } }>
            <View style={ { flex: 1 } }>
                <Text style={ oStyles.exercises_title }>{ oExercises[currentIndex].exercise }</Text>
                <Text style={ oStyles.exercises_title_translate }>{ "(" + oExercises[currentIndex].translate + ")"}</Text>
                <Text style={ oStyles.exercises_question }>{ oExercises[currentIndex].question }</Text>
                <OTextInput
                    isAnswer={ isAnswer }
                    answers={ [ oExercises[currentIndex].answer ] }
                    afterAnswer={ (result) => {
                        if (result.result) {
                            setCorrectAnswers(correctAnswers + 1);
                        }
                    } }
                />
                <Text style={ [oStyles.exercises_answer, !isAnswer ? { display: 'none' } : {}] }>{ "Ответ: " + oExercises[currentIndex].answer }</Text>
            </View>
            <View style={ isAnswer ? { display: 'none' } : {} }>
                <OAnswerButton
                    title="Проверить"
                    onPress={ () => {
                        setIsAnswer(true);
                    } }
                />
            </View>
            <View style={ !isAnswer ? { display: 'none' } : {} }>
                <OAnswerButton
                    title={ (currentIndex < oExercises.length - 1) ? "Следующее задание" : "Завершить" }
                    onPress={ () => {
                        if ((currentIndex < oExercises.length - 1)) {
                            setIsAnswer(false);
                            setCurrentIndex(currentIndex + 1);
                        }
                        else {
                            Alert.alert(
                                "Результат:", 
                                "Выполнено заданий: " + correctAnswers.toString() + " из " + oExercises.length.toString(),
                                [{
                                    text: "OK",
                                    onPress: () => { navigation.navigate("Lessons"); },
                                    style: "default"
                                }]
                                );
                        }
                    } }
                />
            </View>
        </View>
    );
}